// AUTH FREEZE: Preview-only Identity Toolkit proxy. Do not change login/auth.
const AUTH_HOSTS = [
    'https://identitytoolkit.googleapis.com',
    'https://securetoken.googleapis.com',
];

function shouldPatch(): boolean {
    if (typeof window === 'undefined') {
        return false;
    }
    if (process.env.NODE_ENV === 'production') {
        return false;
    }
    const host = window.location.hostname;
    return host === '127.0.0.1' || host === 'localhost' || host === '[::1]';
}

function rewriteUrl(url: string): string {
    for (const host of AUTH_HOSTS) {
        if (url.startsWith(host)) {
            return `${window.location.origin}/__fbauth/${url.slice('https://'.length)}`;
        }
    }
    return url;
}

export function installLocalFirebaseAuthProxy(): void {
    if (!shouldPatch()) {
        return;
    }

    const originalFetch = window.fetch.bind(window);
    window.fetch = (input: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
        if (typeof input === 'string') {
            return originalFetch(rewriteUrl(input), init);
        }
        if (input instanceof URL) {
            return originalFetch(rewriteUrl(input.href), init);
        }
        const nextUrl = rewriteUrl(input.url);
        if (nextUrl === input.url) {
            return originalFetch(input, init);
        }
        return originalFetch(new Request(nextUrl, input), init);
    };

    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method: string, url: string | URL, ...rest: unknown[]) {
        const next = typeof url === 'string' ? rewriteUrl(url) : rewriteUrl(url.href);
        return originalOpen.apply(this, [method, next, ...rest] as Parameters<typeof originalOpen>);
    };
}
